import React from 'react'
import classNames from 'classnames'

import { Text } from 'components/base'
import Timeago from 'components/Utils/Timeago'
import * as Icons from 'components/Utils/Icons'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import IncentiveBox from 'components/Utils/IncentiveBox'

const getResendStatusText = resendStatus => {
  if (!resendStatus) {
    return 'Resend'
  }
  if (resendStatus.loading) {
    return 'Loading...'
  }
  if (resendStatus.error) {
    return 'Failed.'
  }
  return 'Sent'
}

const getDeleteInviteStatusText = deleteInviteStatus => {
  if (deleteInviteStatus.loading) {
    return 'Deleting...'
  }
  if (deleteInviteStatus.error) {
    return 'Failed.'
  }
  return 'Deleted'
}

export default function InvitationList({
  invites,
  resend,
  deleteInviteStatuses,
  deleteInvite,
  resendInvite,
  style,
  className,
}) {
  return (
    <div className={classNames('radius-normal', className)} style={style}>
      {invites.data.map(invite => {
        const { id, email, inviteCreatedAt } = invite
        const resendStatus = resend[id]
        const deleteInviteStatus = deleteInviteStatuses[id]
        return (
          <div
            key={id}
            className={classNames([
              'flexbox flexbox-align-center',
              'padding-normal background-shade-100 background-shade-50-on-hover radius-large no-outline',
            ])}
          >
            <div className="flexbox-grow ellipsis">
              <span className="shade-10 bold">{email}</span>
              <span className="shade-20 bold font-size-small">
                {' — Invitation sent '}
                <Timeago date={inviteCreatedAt} />
              </span>
            </div>
            <div className="flexbox flexbox-centered flexbox-no-grow">
              <Text.Action
                onClick={e => {
                  e.preventDefault()
                  resendInvite(invite)
                }}
              >
                {getResendStatusText(resendStatus)}
              </Text.Action>

              <div className="flexbox flexbox-centered padding-left-large shade-30">
                {deleteInviteStatus ? (
                  getDeleteInviteStatusText(deleteInviteStatus)
                ) : (
                  <TooltipOnHover
                    id={`delete-invite-${invite.id}`}
                    tooltipContent="Delete invite"
                    placement="right"
                  >
                    <div
                      className="pointer red-on-hover"
                      onClick={() => deleteInvite(invite)}
                    >
                      <Icons.DeleteIcon size={14} />
                    </div>
                  </TooltipOnHover>
                )}
              </div>
            </div>
          </div>
        )
      })}
      <IncentiveBox
        incentiveId="ManageWhoCanInvite"
        className="margin-vertical-larger"
      />
    </div>
  )
}
